import { useTranslation } from 'react-i18next';

const WeakConnectionIndicator = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        position: 'absolute',
        zIndex: '9999',
        background: '#FFC107',
        width: '100%',
        color: '#000',
        textAlign: 'center',
        fontSize: '12px'
      }}
    >
      <span> {t('weak-connection-indicator.title')}</span>
    </div>
  );
};

export default WeakConnectionIndicator;
